var map = {
	"./image-carousel.de-CH.json": 1568,
	"./image-carousel.de-DE.json": 1569,
	"./image-carousel.en-CA.json": 1570,
	"./image-carousel.en-GB.json": 1571,
	"./image-carousel.en-IN.json": 1572,
	"./image-carousel.en-ME.json": 1573,
	"./image-carousel.en-US.json": 1574,
	"./image-carousel.es-EM.json": 1575,
	"./image-carousel.es-ES.json": 1576,
	"./image-carousel.fr-BE.json": 1577,
	"./image-carousel.fr-CA.json": 1578,
	"./image-carousel.fr-CH.json": 1579,
	"./image-carousel.nl-BE.json": 1580,
	"./image-carousel.nl-NL.json": 1581,
	"./image-carousel.pl-PL.json": 1582,
	"./image-carousel.pt-BR.json": 1583
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1567;